module.exports = __webpack_public_path__ + "img/qt.117b8ab8.png";